/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { onboardingCreateInvite } from "../../funcs/onboardingCreateInvite.js";
import * as components from "../../models/components/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: components.OnboardingInviteRequest$inboundSchema,
};

export const tool$onboardingCreateInvite: ToolDefinition<typeof args> = {
  name: "onboarding-create-invite",
  description:
    `Create an invitation containing a unique link that allows the recipient to onboard their organization with Moov.

To access this endpoint using an [access token](https://docs.moov.io/api/authentication/access-tokens/) 
you'll need to specify the \`/accounts.write\` scope.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await onboardingCreateInvite(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value.result;

    return formatResult(value, apiCall);
  },
};
